import * as React from 'react';
import LexiconLanguage from '../new/lexicons/LexiconLanguage';
import './LexiconSearchBox.css';

interface Props {
    language: LexiconLanguage;
    searchText: string;
    onChange: (text: string) => void;
    onSubmit: (text: string) => void;
}

export default class LexiconSearchBox extends React.Component<Props> {

    public constructor(props: Props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
    }

    public render() {
        const showPlaceholderText = this.props.searchText === '';

        const classes = ['LexiconSearchBox'];
         if (!showPlaceholderText) {
            classes.push(this.props.language === LexiconLanguage.Hebrew ? '_Hebrew' : '_Greek');
        }

        return (
            <div className={classes.join(' ')}>
                <input
                    type="text"
                    value={this.props.searchText}
                    placeholder={showPlaceholderText ? 'Search lexicon' : ''}
                    onChange={this.onChange}
                    onKeyUp={this.onKeyUp} />
            </div>
        );
    }

    private onChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.props.onChange(event.target.value);
    }

    private onKeyUp(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.keyCode === 13) {
            this.props.onSubmit(this.props.searchText);
        }
    }
}
